<template>
  <div class="building-manage">
    <div class="top-filter">
      <!-- 老的选择学校的方式： -->
      <!-- <a-select
              placeholder="请选择一个学校"
              style="width: 200px; margin-right: 30px"
              v-model="schoolCode"
              @change="getBuildingList"
              optionFilterProp="children"
              :getPopupContainer="triggerNode => triggerNode.parentNode"
            >
                <a-select-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :value="item.schoolId"
                >
                  {{ item.schoolName }}
                </a-select-option>
            </a-select> -->
      <!-- 新的选择学校的方式： -->
      <div class="org_container">
        <p class="org_container_name">{{ schoolSelectName || '- -' }}</p>
        <img
          class="org_container_icon"
          src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/ddd303c5e801417d820d391216d4e848.png"
          alt="切换"
          @click="switchingSchoolDialogFlag = true"
        />
      </div>
    </div>
    <div class="building-content">
      <div class="current-school">
        <!-- <div class="school-name">{{ currentSchoolName }}</div> -->
        <div class="school-name">{{ schoolSelectName }}</div>
        <a-dropdown>
          <a-icon type="more" />
          <!-- <a-menu slot="overlay">
                        <a-menu-item key="1" @click="handleItem(currentSchoolName, '', '', 1)">
                          <span>新增校区</span>
                        </a-menu-item>
                    </a-menu> -->
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="handleItem(schoolSelectName, '', '', 1)">
              <span>新增校区</span>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
      <a-tree
        v-if="buildingData && buildingData.length"
        class="draggable-tree"
        blockNode
        draggable
        defaultExpandAll
        :expanded-keys.sync="expandedKeys"
        :auto-expand-parent="autoExpandParent"
        :replaceFields="replaceFields"
        :tree-data="buildingData"
        @dragstart="onDragstart"
        @dragenter="onDragEnter"
        @drop="onDrop"
        @expand="onExpand"
        @select="treeSelect"
      >
        <template #title="{ name, id, level, sort }">
          <div class="tree-line" @mouseenter="handleTitleShow(id)">
            <div
              class="tree-title text-overflow-one"
              :id="'building-tree-' + id"
              :title="showDomTitle ? name : undefined"
            >
              {{ name }}
            </div>
            <div class="title-right">
              <a-dropdown>
                <a-icon type="more" />
                <a-menu slot="overlay">
                  <a-menu-item key="2" v-if="level == 1" @click="handleItem(name, id, sort, 2)">
                    <span>编辑校区</span>
                  </a-menu-item>
                  <a-menu-item key="3" v-if="level == 1" @click="handleItem(name, id, sort, 3)">
                    <span>新增教学楼</span>
                  </a-menu-item>
                  <a-menu-item key="4" v-if="level == 2" @click="handleItem(name, id, sort, 4)">
                    <span>编辑教学楼</span>
                  </a-menu-item>
                  <a-menu-item key="5" @click="delItem(id, level, 5)">
                    <span style="color: red">删除</span>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
          </div>
        </template>
      </a-tree>
    </div>

    <AddOrEditDialog
      :showDialogProp.sync="showDialogProp"
      :name="currentName"
      :currentKey="currentKey"
      @handleSave="handleSave"
    />
    <DeleteDialog
      :showDelDialogProp.sync="showDelDialogProp"
      :delTitle="delTitle"
      :tipText="tipText"
      @handleDel="handleDel"
    />
    <DelFailDialog
      :showDelFailDialogProp.sync="showDelFailDialog"
      :delTitle="delTitle"
      :tipText="tipText"
      @handleDel="handleDel"
    />
    <switching-school
      :switchingSchoolDialogFlag="switchingSchoolDialogFlag"
      @handleSwitchingSchoolDialogClose="handleSwitchingSchoolDialogClose"
    />
  </div>
</template>
<script>
import AddOrEditDialog from './components/addOrEditDialog.vue'
import DeleteDialog from './components/delDailog.vue'
import DelFailDialog from './components/delFailDialog.vue'
// import { getSchoolBuilding } from '@/server/api/buildingManagement.js'
import { mapGetters } from 'vuex'

export default {
  name: 'BuildingManagement',
  data() {
    return {
      schoolCode: '',
      currentSchoolName: '',
      schoolList: [],
      buildingData: [],
      replaceFields: {
        children: 'buildingInfos',
        title: 'name',
        key: 'id'
      },
      showDialogProp: false,
      currentCampusInfo: {},
      currentBuildingInfo: {},
      currentName: '',
      currentKey: 0,
      currentSort: 0,
      showDelDialogProp: false,
      showDelFailDialog: false,
      delTitle: '',
      tipText: '',
      findResult: '',
      buildingSortArr: [],
      expandedKeys: [],
      autoExpandParent: true,
      showDomTitle: false,
      switchingSchoolDialogFlag: false
    }
  },
  created() {
    // this.getSchoolList()
  },
  components: {
    AddOrEditDialog,
    DeleteDialog,
    DelFailDialog,
    'switching-school': () => import('@/components/switchingSchool')
  },
  computed: {
    ...mapGetters('switchingSchool', ['schoolSelect', 'schoolSelectName'])
  },
  watch: {
    schoolSelect: {
      handler: function (newVal) {
        if (!newVal) return
        this.schoolCode = newVal
        this.getBuildingList()
      },
      immediate: true
    }
  },
  methods: {
    // 获取学校列表
    async getSchoolList() {
      // 初始化各项的值
      try {
        let schoolRes = await this.$http.getSelectSchoolList()
        if (schoolRes.code !== 200) {
          throw '初始化学校失败!请稍候重试'
        } else {
          this.schoolList = schoolRes.rt
          console.log('schoolList:>>>>>>>', this.schoolList)
          this.schoolCode = this.schoolList[0]?.schoolId || ''
          this.currentSchoolName = this.schoolList[0]?.schoolName || ''
          await this.getBuildingList()
        }
      } catch (error) {
        // this.$message.error(error)
      }
    },
    // 切换学校时更新列表
    async getBuildingList() {
      const buildingRes = await this.$http.getSchoolBuilding({
        schoolCode: this.schoolCode
      })
      if (buildingRes.code == 200) {
        this.buildingData = buildingRes.rt || []
        this.buildingData = this.handleData(buildingRes.rt, 1)
        this.buildingData.sort((a, b) => a.sort - b.sort)
        this.buildingData.map((item) => {
          this.expandedKeys.push(item.id)
        })
        console.log('this.buildingData', this.buildingData)
      }
      this.currentSchoolName = this.schoolList.find((item) => item.schoolId == this.schoolCode).schoolName
    },
    handleData(data, level) {
      data.forEach((children) => {
        children.name = children.campusName || children.buildingName
        children.id = children.campusId || children.buildingId
        children.level = level
        children.sort = children.campusSort || children.buildingSort
        if (children.buildingInfos && children.buildingInfos.length) {
          this.handleData(children.buildingInfos, 2)
        }
      })
      return data
    },
    onExpand(expandedKeys) {
      //   console.log('onExpand', expandedKeys);
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onDragstart({ event, node }) {
      if (node.dataRef.level == 1) {
        this.expandedKeys = []
      }
    },
    onDragEnter(info, node) {
      // console.log('onDragEnter:>>>>>>>>>>', info, node);
      // expandedKeys 需要受控时设置
      // this.expandedKeys = info.expandedKeys
    },
    async onDrop(info) {
      // console.log('onDrop:>>>>>>>>>>>>', info);
      const sortLevel = info.node.dataRef.level
      const dropKey = info.node.eventKey // dropKey是拖拽后所落在的节点key，info.node 落下的节点信息
      const dragKey = info.dragNode.eventKey // 拖拽的节点key info.dragNode是拖拽的节点信息
      const dropPos = info.node.pos.split('-')
      // dropPosition -1是移动到和他平级在他上面  1是移动到和他平级在他下面  0是移动到他下面作为他子集 info.dropPosition是落下的位置信息
      const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])
      // 限制只能同级拖动
      const dealData = JSON.parse(JSON.stringify(this.buildingData))
      // result true 同级 false 非同级
      const result = this.dealDrap(info.dragNode, info.node, [...dealData], dropPosition)
      if (!result) return this.$message.warning('只能在同级之间拖拽排序哦')

      const loop = (data, key, callback) => {
        data.forEach((item, index, arr) => {
          if (item.id === key) {
            return callback(item, index, arr)
          }
          if (item.buildingInfos) {
            return loop(item.buildingInfos, key, callback)
          }
        })
      }
      const data = [...this.buildingData]

      // Find dragObject
      let dragObj
      loop(data, dragKey, (item, index, arr) => {
        arr.splice(index, 1)
        dragObj = item
        this.buildingSortArr = arr
      })
      if (!info.dropToGap) {
        // Drop on the content
        loop(data, dropKey, (item) => {
          item.buildingInfos = item.buildingInfos || []
          // where to insert 示例添加到尾部，可以是随意位置
          item.buildingInfos.push(dragObj)
        })
      } else if (
        (info.node.children || []).length > 0 && // Has children
        info.node.expanded && // Is expanded
        dropPosition === 1 // On the bottom gap
      ) {
        loop(data, dropKey, (item) => {
          item.buildingInfos = item.buildingInfos || []
          // where to insert 示例添加到尾部，可以是随意位置
          item.buildingInfos.unshift(dragObj)
          console.log('222----------', item)
        })
      } else {
        let ar
        let i
        loop(data, dropKey, (item, index, arr) => {
          ar = arr
          i = index
        })
        if (dropPosition === -1) {
          ar.splice(i, 0, dragObj)
        } else {
          ar.splice(i + 1, 0, dragObj)
        }
        this.buildingSortArr = ar
      }
      this.buildingData = data
      if (sortLevel == 1) {
        await this.sortCampusList()
      } else if (sortLevel == 2) {
        await this.sortBuildingList()
      }
    },
    findItem(data, node, parentItem) {
      data.find((item) => {
        if (item?.id === node?.eventKey) {
          if (parentItem) {
            item.parent = parentItem
            return (this.findResult = item)
          } else return (this.findResult = item)
        } else if (item?.buildingInfos?.length) {
          return (this.findResult = this.findItem(item.buildingInfos, node, item))
        }
      })
      return this.findResult
    },
    dealDrap(dragNode, node, treeData, dropPosition) {
      let dragNodeResult, nodeResult
      this.findResult = ''
      dragNodeResult = this.findItem(treeData, dragNode) // 拖拽的节点信息
      // console.log('dragNodeResult:>>>>>>>>>', dragNodeResult);
      this.findResult = ''
      nodeResult = this.findItem(treeData, node) // 落下的节点信息
      // console.log('nodeResult:>>>>>>>>', nodeResult);
      // 0是移动到他下面作为他子集
      if (dropPosition === 0) {
        if (dragNodeResult?.parent?.id === nodeResult?.id) return true
        return false
      }
      // -1是移动到和他平级在他上面    1是移动到和他平级在他下面
      if (dropPosition === 1 || dropPosition === -1) {
        // 都有父
        if (dragNodeResult?.parent && nodeResult?.parent) {
          // 父相等
          if (dragNodeResult?.parent?.id == nodeResult?.parent?.id) {
            return true
          } else {
            return false
          }
        }
        //有父无父
        if (dragNodeResult?.parent && !nodeResult?.parent) {
          return false
        }
        // 无父有父
        if (!dragNodeResult?.parent && nodeResult?.parent) {
          return false
        }
        if (!dragNodeResult?.parent && !nodeResult?.parent) {
          return true
        }
      }
    },
    // 新增/编辑校区、楼栋
    handleItem(name, id, sort, num) {
      this.showDialogProp = true
      this.currentKey = num
      this.currentName = name
      switch (num) {
        case 1:
          break
        case 2:
          this.currentCampusInfo.campusId = id
          this.currentCampusInfo.campusName = name
          break
        case 3: // 新增楼栋
          this.currentCampusInfo.campusId = id
          break
        case 4: // 编辑楼栋
          this.currentBuildingInfo = {
            name: name,
            id: id,
            sort: sort
          }
          break

        default:
          break
      }
    },
    handleEmptyName() {
      this.currentName = ''
    },
    handleSave(name) {
      switch (this.currentKey) {
        case 1: // 新增校区
          this.creatNewCampus(name)
          break
        case 2: // 编辑校区
          this.updateCampus(name)
          break
        case 3: // 新增教学楼
          this.creatNewBuilding(name)
          break
        case 4: // 编辑教学楼
          let currentCampusId = this.getCampusId(this.buildingData, this.currentBuildingInfo.id)
          console.log('currentCampusId', currentCampusId)
          this.updateBuilding(name, currentCampusId)
          break
      }
    },
    // 新增楼栋
    async creatNewBuilding(name) {
      const res = await this.$http.creatBuilding({
        schoolCode: this.schoolCode,
        campusId: this.currentCampusInfo.campusId,
        buildingName: name,
        buildingSort: 0
      })
      console.log('creatBuilding:>>>>>>', res)
      if (res.code == 200 && res.rt.resultStatus == 1) {
        this.$message.success('操作成功')
        this.getBuildingList()
        this.showDialogProp = false
      }
    },
    // 编辑楼栋
    async updateBuilding(name, campusId) {
      const res = await this.$http.updateBuilding({
        buildingId: this.currentBuildingInfo.id,
        campusId: campusId,
        buildingName: name,
        buildingSort: this.currentBuildingInfo.sort
      })
      console.log('updateBuilding:>>>>>>', res)
      if (res.code == 200 && res.rt) {
        this.$message.success('操作成功')
        this.getBuildingList()
        this.showDialogProp = false
      }
    },
    getCampusId(arr, id) {
      let campusId = ''
      arr.map((item) => {
        if (item.buildingInfos && item.buildingInfos.length) {
          let currentBuilding = item.buildingInfos.find((building) => building.buildingId == id)
          console.log('currentBuilding', currentBuilding, item)
          if (currentBuilding) {
            campusId = item.campusId
          }
        }
      })
      return campusId
    },
    // 删除校区/楼栋
    delItem(id, level, num) {
      if (level == 1) {
        this.delTitle = '删除校区'
        this.tipText = '确认要删除此校区吗？'
        this.currentCampusInfo.campusId = id
      } else if (level == 2) {
        this.delTitle = '删除教学楼'
        this.tipText = '确认要删除此教学楼吗？'
        this.currentBuildingInfo.id = id
      }
      this.delLevel = level
      this.showDelDialogProp = true
    },
    async handleDel() {
      switch (this.delLevel) {
        case 1:
          const delCampusRes = await this.$http.deleteCampus({
            campusId: this.currentCampusInfo.campusId
          })
          console.log('delCampusRes', delCampusRes)
          if (delCampusRes.code == 200 && delCampusRes.rt.resultStatus == 1) {
            this.$message.success('操作成功')
            this.getBuildingList()
            this.showDelDialogProp = false
          } else if (delCampusRes.code == 200 && delCampusRes.rt.resultStatus == -1) {
            this.showDelDialogProp = false
            this.tipText = delCampusRes.rt.resultMessage
            this.showDelFailDialog = true
          }
          break
        case 2:
          const delRes = await this.$http.delCurrentBuilding({
            buildingId: this.currentBuildingInfo.id
          })
          console.log('delRes', delRes)
          if (delRes.code == 200 && delRes.rt.resultStatus == 1) {
            this.$message.success('操作成功')
            this.getBuildingList()
            this.showDelDialogProp = false
          } else if (delRes.code == 200 && delRes.rt.resultStatus == -1) {
            this.showDelDialogProp = false
            this.tipText = delRes.rt.resultMessage
            this.showDelFailDialog = true
          }
          break
      }
    },
    // 楼栋排序
    async sortBuildingList() {
      let sortList = []
      this.buildingSortArr.map((item, index) => {
        const sortItem = {
          id: item.buildingId,
          sort: index + 1
        }
        sortList.push(sortItem)
      })
      const sortRes = await this.$http.sortBuilding({
        sortList: sortList
      })
      if (sortRes.code == 200 && sortRes.rt.resultStatus == 1) {
        this.getBuildingList()
      }
    },
    // 新增校区
    async creatNewCampus(name) {
      try {
        const res = await this.$http.creatCampus({
          schoolCode: this.schoolCode,
          name: name
        })
        if (res.code == 200 && res.rt) {
          this.$message.success('操作成功')
          this.getBuildingList()
          this.showDialogProp = false
        }
      } catch (error) {
        console.log('creatCampusError', error)
      }
    },
    // 编辑校区
    async updateCampus(name) {
      try {
        const res = await this.$http.updateCampus({
          id: this.currentCampusInfo.campusId,
          name: name
        })
        if (res.code == 200 && res.rt) {
          this.$message.success('操作成功')
          this.getBuildingList()
          this.showDialogProp = false
        }
      } catch (error) {
        console.log('updateCampusError', error)
      }
    },
    // 校区排序
    async sortCampusList() {
      let sortList = []
      this.buildingSortArr.map((item, index) => {
        const sortItem = {
          id: item.campusId,
          sort: index + 1
        }
        sortList.push(sortItem)
      })
      try {
        const res = await this.$http.sortCampus({
          sortList: sortList
        })
        if (res.code == 200 && res.rt) {
          this.$message.success('操作成功')
          this.getBuildingList()
          this.showDialogProp = false
        }
      } catch (error) {
        console.log('sortCampusError', error)
      }
    },
    handleTitleShow(id) {
      const currentDom = document.getElementById(`building-tree-${id}`)
      let textWidth = currentDom.scrollWidth || 0
      let domWidth = currentDom.clientWidth || 0
      if (textWidth > domWidth) {
        this.showDomTitle = true
      } else {
        this.showDomTitle = false
      }
    },
    handleSwitchingSchoolDialogClose() {
      this.switchingSchoolDialogFlag = false
    },
    treeSelect(s, e) {
      e.node.onExpand()
    }
  }
}
</script>
<style lang="scss" scoped>
.building-manage {
  min-height: calc(100vh - 56px - 40px);
  text-align: left;
  .top-filter {
    position: relative;
    width: 100%;
    height: 70px;
    padding-left: 16px;
    background: #fff;
    display: flex;
    align-items: center;
    .org_container {
      display: flex;
      align-items: center;
      .org_container_name {
        font-size: 14px;
        color: #1e2228;
        margin-right: 8px;
      }
      .org_container_icon {
        width: 16px;
        height: 16px;
        display: block;
        cursor: pointer;
        user-select: none;
      }
    }
  }
  .building-content {
    margin-top: 16px;
    min-height: calc(100vh - 56px - 40px - 70px - 16px);
    padding: 16px;
    background: #fff;
  }
  .current-school {
    height: 52px;
    width: 100%;
    padding-right: 16px;
    font-size: 14px;
    padding-left: 20px;
    color: #515560;
    background: #ebedf0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.draggable-tree {
  .tree-line {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tree-title {
      flex: 1;
      padding-right: 10px;
      color: #000;
    }
    .title-right {
      width: 25px;
    }
  }
}

::v-deep {
  .ant-select-selection--single {
    height: 32px;
  }
  .ant-select-selection__rendered {
    line-height: 32px;
  }
  .ant-tree li {
    padding: 0;
  }
  .ant-tree li ul {
    padding: 0;
  }
  .anticon {
    vertical-align: -0.28em !important;
  }
  .ant-tree-block-node li:hover,
  .ant-tree-child-tree li:hover {
    background: #fff;
    box-shadow: 0px -2px 20px 0px rgba(13, 23, 51, 0.1);
  }
  .ant-tree li .ant-tree-node-content-wrapper {
    width: calc(100% - 24px);
    height: 52px;
    line-height: 52px;
    border-bottom: 1px solid #eee;
    &:hover {
      background: #fff;
      color: #000;
      .ant-tree-title {
        height: 52px;
        line-height: 52px;
        color: #000;
      }
      .ant-tree li span.ant-tree-switcher {
        background: #fff;
      }
    }
  }
  .ant-tree li span.ant-tree-switcher {
    height: 52px;
    line-height: 52px;
    border-bottom: 1px solid #eee;
  }
  .ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-icon,
  .ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-select-switcher-icon,
  .ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon,
  .ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-select-switcher-icon {
    font-size: 16px;
  }
  .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background: transparent;
  }
}
</style>
